import Card from "@/components/Card"
import { Badge } from "@/components/ui/badge"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { listPanduanLoketDaftarKembali } from "@/constants"
import { useEffect, useState } from "react"
import { LuChevronRight } from "react-icons/lu"
import { MdBlock, MdSearch } from "react-icons/md"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"
import Loket1 from "./loket-1/Loket1"
import Loket2 from "./loket-2/Loket2"
import Loket3 from "./loket-3/Loket3"
import Loket4 from "./loket-4/Loket4"
import Loket5 from "./loket-5/Loket5"
import { useQuery } from "@tanstack/react-query"
import api from "@/lib/axios"
import { useDebounce } from "@/hooks/useDebounce"
import SkeletonRow from "@/components/SkeletonRow"
import { DataPendaftaran, DataSiswa } from "@/types"
import { FaUser } from "react-icons/fa6"
import { Loader2 } from "lucide-react"
import { IoCheckmarkDoneCircle, IoPlaySkipForwardCircle } from "react-icons/io5"
import { RiLoader2Fill } from "react-icons/ri"
import useScreen from "@/hooks/useScreen"
import { useUser } from "@/hooks/useUser"
import toast from "react-hot-toast"

const menus = [
  { no: 1, name: "Loket 1", color: "bg-[#FFFBE7]" },
  { no: 2, name: "Loket 2", color: "bg-[#EAFFEE]" },
  { no: 3, name: "Loket 3", color: "bg-[#E6FFFA]" },
  { no: 4, name: "Loket 4", color: "bg-[#ECEEFF]" },
  { no: 5, name: "Loket 5", color: "bg-[#FFE7F9]" },
]

const getListDataSiswa = async (searchQuerySiswa: string) => {
  const response = await api.get(
    `/verifikator/daftar-kembali/search/siswa?search=${searchQuerySiswa}`
  )
  return response.data
}

const getDataStatusLoket = async (nomor_pendaftaran: string) => {
  const response = await api.get(
    `/verifikator/daftar-kembali/status-loket?nomor_pendaftaran=${nomor_pendaftaran}`
  )
  return response.data
}

export default function LoketmanPage() {
  const { user } = useUser()
  const { isMobile } = useScreen()
  const location = useLocation()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const nomorParams = searchParams.get("no")
  const idParams = searchParams.get("id")

  const [showListSiswa, setShowListSiswa] = useState(false)
  const [selectedSiswa, setSelectedSiswa] = useState<DataSiswa | null>(null)
  const [searchQuerySiswa, setSearchQuerySiswa] = useState(idParams || "")
  const [currentIndex, setCurrentIndex] = useState(0)
  const [showPanduan, setShowPanduan] = useState(true)
  const [visibleCount, setVisibleCount] = useState(3)
  const handleLoadMore = () => setVisibleCount((prevCount) => prevCount + 5)

  const debouncedQuery = useDebounce(searchQuerySiswa, 1000)

  const {
    data: listDataSiswa,
    isPending: isPendingDataSsiwa,
    // error: errorListDataSiswa,
  } = useQuery({
    queryKey: ["listDataSiswa", debouncedQuery],
    queryFn: () => getListDataSiswa(debouncedQuery),
    enabled: !!debouncedQuery,
  })

  const { data: dataStatusLoket, isPending: isPendingDataStatusLoket } =
    useQuery({
      queryKey: ["dataStatusLoket", idParams],
      queryFn: () => getDataStatusLoket(idParams || ""),
      enabled: !!idParams,
    })

  const lokets = [
    {
      no: 1,
      title: "Verifikasi Biodata & Pembayaran UKT/KIPK",
      description:
        "Mahasiswa menunjukkan Biodata dan menunjukkan kwitansi pembayaran UKT dari Bank atau Bukti Penerima KIPK",
      component: <Loket1 />,
    },
    {
      no: 2,
      title: "Tes Buta Warna",
      description: "Mahasiswa menunjukkan Biodata",
      component: (
        <Loket2
          disabled={
            !dataStatusLoket?.data ||
            dataStatusLoket?.data?.status_loket_1 === null ||
            dataStatusLoket?.data?.status_loket_1 === 0
          }
        />
      ),
    },
    {
      no: 3,
      title: "Verifikasi Beasiswa KIPK",
      description: "Mahasiswa menunjukkan Biodata dan Verifikasi KIP Kuliah",
      component: (
        <Loket3
          disabled={
            !dataStatusLoket?.data ||
            dataStatusLoket?.data?.status_loket_1 === null ||
            dataStatusLoket?.data?.status_loket_1 === 0 ||
            (dataStatusLoket?.data?.is_cek_butawarna &&
              (dataStatusLoket?.data?.status_loket_2 === null ||
                dataStatusLoket?.data?.status_loket_2 === 0))
          }
        />
      ),
    },
    {
      no: 4,
      title: "Verifikasi Rapor,Ijazah/SKL, Prestasi",
      description:
        "Mahasiswa menunjukkan Biodata, Raport Asli, dan Surat Keterangan Lulus/Ijazah, dan Prestasi (bagi yang memiliki)",
      component: (
        <Loket4
          disabled={
            !dataStatusLoket?.data ||
            dataStatusLoket?.data?.status_loket_1 === null ||
            dataStatusLoket?.data?.status_loket_1 === 0 ||
            (dataStatusLoket?.data?.is_cek_butawarna &&
              (dataStatusLoket?.data?.status_loket_2 === null ||
                dataStatusLoket?.data?.status_loket_2 === 0)) ||
            (dataStatusLoket?.data?.is_beasiswa_penuh &&
              (dataStatusLoket?.data?.status_loket_3 === null ||
                dataStatusLoket?.data?.status_loket_3 === 0))
          }
        />
      ),
    },
    {
      no: 5,
      title: "Validasi data SIAK",
      description: "Mahasiswa menunjukkan Biodata",
      component: (
        <Loket5
          disabled={
            !dataStatusLoket?.data ||
            dataStatusLoket?.data?.status_loket_1 === null ||
            dataStatusLoket?.data?.status_loket_1 === 0 ||
            (dataStatusLoket?.data?.is_cek_butawarna &&
              (dataStatusLoket?.data?.status_loket_2 === null ||
                dataStatusLoket?.data?.status_loket_2 === 0)) ||
            (dataStatusLoket?.data?.is_beasiswa_penuh &&
              (dataStatusLoket?.data?.status_loket_3 === null ||
                dataStatusLoket?.data?.status_loket_3 === 0)) ||
            dataStatusLoket?.data?.status_loket_4_1 === null ||
            dataStatusLoket?.data?.status_loket_4_1 === 0 ||
            dataStatusLoket?.data?.status_loket_4_2 === null ||
            dataStatusLoket?.data?.status_loket_4_2 === 0
          }
        />
      ),
    },
  ]

  const panduan = listPanduanLoketDaftarKembali[currentIndex]
  const loket = lokets[currentIndex]

  const userRoles = user?.jenis_user
  const isLoketman = userRoles?.includes("loket_all")
  const loketmanRoles = userRoles
    ?.filter((role) => role.startsWith("loket"))
    .map((role) => role.split("_")[1])

  useEffect(() => {
    if (!nomorParams) return

    const newIndex = Number(nomorParams) - 1
    if (newIndex !== currentIndex) {
      setCurrentIndex(newIndex)
    }
  }, [nomorParams, currentIndex])

  useEffect(() => {
    if (searchParams && idParams && nomorParams) {
      navigate(`${location.pathname}?no=${nomorParams}&id=${idParams}`)
    } else {
      const nomorPendaftaran =
        selectedSiswa?.data_pendaftaran?.[0]?.nomor_pendaftaran || ""
      searchParams.set("id", nomorPendaftaran)

      navigate(`${location.pathname}?${searchParams.toString()}`)
    }
  }, [
    debouncedQuery,
    location.pathname,
    navigate,
    searchParams,
    idParams,
    nomorParams,
    selectedSiswa,
    searchQuerySiswa,
  ])

  useEffect(() => {
    if (isMobile) setShowPanduan(false)
    else setShowPanduan(true)
  }, [isMobile])

  // CEK KESESUAIAN ROLE BERDASARKAN LOKET YANG DIAKSES
  useEffect(() => {
    const validLoketmanRoles = loketmanRoles ?? []

    if (validLoketmanRoles.length === 0) navigate(`/`)
    if (!isLoketman && !validLoketmanRoles.includes(nomorParams || ""))
      navigate(
        `/loket?no=${
          validLoketmanRoles[validLoketmanRoles.length - 1] ?? "1"
        }&id=${idParams}`
      )
  }, [nomorParams, idParams, isLoketman, loketmanRoles, navigate])
  //

  return (
    <main className="mt-10">
      <div className="grid lg:grid-cols-5 md:grid-cols-3 grid-cols-1 gap-5">
        {menus.map((item, index) => {
          const active = item.no === Number(nomorParams)

          const statusLoket = dataStatusLoket?.data?.[`status_loket_${item.no}`]
          // const statusLoketBefore =
          //   item.no && dataStatusLoket?.data?.[`status_loket_${item.no - 1}`];

          const isValidLoket4 =
            dataStatusLoket?.data?.[`status_loket_4_1`] == 1 &&
            dataStatusLoket?.data?.[`status_loket_4_2`] == 1
          const isNotValidLoket4 =
            dataStatusLoket?.data?.[`status_loket_4_1`] == 0 &&
            dataStatusLoket?.data?.[`status_loket_4_2`] == 0

          const isUnauthorizedLoketRole =
            !isLoketman && !loketmanRoles?.includes(String(item.no))

          return (
            <div
              key={index}
              onClick={() => {
                // if (
                //   statusLoketBefore === null ||
                //   (statusLoketBefore !== 1 && item.no !== 1 && idParams)
                // ) {
                //   toast.error(`Loket ${item.no - 1} belum divalidasi`);
                // } else if (isLoketman) {
                //   navigate(`${location.pathname}?no=${item.no}&id=${idParams}`);
                //   setCurrentIndex(index);
                // } else if (loketmanRoles?.includes(String(item.no))) {
                //   navigate(`${location.pathname}?no=${item.no}&id=${idParams}`);
                //   setCurrentIndex(index);
                // }
                if (isLoketman) {
                  navigate(`${location.pathname}?no=${item.no}&id=${idParams}`)
                  setCurrentIndex(index)
                } else if (loketmanRoles?.includes(String(item.no))) {
                  navigate(`${location.pathname}?no=${item.no}&id=${idParams}`)
                  setCurrentIndex(index)
                } else {
                  toast.error(`Anda memiliki akses loket ${item.no}`)
                }
              }}
            >
              <Card
                className={`${item.color} ${
                  active ? "border-black" : "border-transparent"
                } min-h-[7rem] ${
                  isUnauthorizedLoketRole
                    ? "opacity-60 cursor-not-allowed"
                    : "cursor-pointer"
                }`}
              >
                <div className="flex items-center justify-between">
                  <div>
                    <h1 className="font-semibold">{item.name}</h1>
                    <p className="text-sm text-muted-foreground">
                      {!dataStatusLoket && !idParams
                        ? ""
                        : isPendingDataStatusLoket
                        ? ""
                        : item.no === 4
                        ? isValidLoket4
                          ? "Sudah valid, lanjut ke loket berikutnya"
                          : isNotValidLoket4
                          ? "Tidak valid"
                          : "Menunggu Validasi"
                        : statusLoket === null
                        ? item.no === 2 &&
                          !dataStatusLoket?.data?.is_cek_butawarna
                          ? "Skip"
                          : item.no === 3 &&
                            !dataStatusLoket?.data?.is_beasiswa_penuh
                          ? "Skip"
                          : "Menunggu Validasi"
                        : statusLoket === 1
                        ? "Sudah Valid, lajut ke loket berikutnya"
                        : statusLoket === 0
                        ? "Tidak Valid"
                        : "Menunggu Validasi"}
                    </p>
                  </div>
                  {isPendingDataStatusLoket ? (
                    <Loader2 className="w-4 h-4 animate-spin" />
                  ) : (
                    <div>
                      {!dataStatusLoket && !idParams ? (
                        ""
                      ) : item.no === 4 ? (
                        isValidLoket4 ? (
                          <IoCheckmarkDoneCircle />
                        ) : isNotValidLoket4 ? (
                          <MdBlock />
                        ) : (
                          <RiLoader2Fill />
                        )
                      ) : statusLoket !== null ? (
                        statusLoket == 1 ? (
                          <IoCheckmarkDoneCircle />
                        ) : statusLoket == 0 ? (
                          <MdBlock />
                        ) : (
                          <RiLoader2Fill />
                        )
                      ) : item.no === 2 &&
                        !dataStatusLoket?.data?.is_cek_butawarna ? (
                        <IoPlaySkipForwardCircle />
                      ) : item.no === 3 &&
                        !dataStatusLoket?.data?.is_beasiswa_penuh ? (
                        <IoPlaySkipForwardCircle />
                      ) : (
                        <RiLoader2Fill />
                      )}
                    </div>
                  )}
                </div>
              </Card>
            </div>
          )
        })}
      </div>
      <section className="mt-10">
        <div className="flex flex-wrap justify-between gap-10">
          <div className="lg:w-[50%] w-full">
            <div className="font-bold text-xl flex items-center gap-3">
              <h1>{loket?.title}</h1>
              <Badge variant={"dark"} className="h-fit">
                Loket {nomorParams}
              </Badge>
            </div>
            <p className="text-muted-foreground">{loket?.description}</p>
          </div>
          <div className="flex-1">
            <div className="z-20 relative">
              <Input
                placeholder="Cari peserta menggunakan nama/nomor pendaftaran..."
                className="bg-white border"
                value={searchQuerySiswa}
                onChange={(event) => {
                  setSearchQuerySiswa(event.target.value)
                  setShowListSiswa(true)
                }}
              />
              <button className="h-10 w-10 absolute right-0 top-0 rounded-full bg-black/90 text-white flex justify-center items-center">
                <MdSearch />
              </button>
              {debouncedQuery && showListSiswa && (
                <div className="top-12 absolute w-full">
                  <div className="max-h-[20rem] overflow-y-auto border rounded-xl p-5 bg-white shadow-md">
                    {isPendingDataSsiwa ? (
                      <div className="flex flex-col gap-y-3">
                        {Array(5)
                          .fill(null)
                          .map((_, index) => {
                            return <SkeletonRow key={index} />
                          })}
                      </div>
                    ) : (
                      <div className="flex flex-col">
                        {listDataSiswa?.data?.length > 0
                          ? listDataSiswa?.data?.map((item: DataSiswa) => {
                              const dataPendaftaran:
                                | DataPendaftaran
                                | undefined =
                                item?.data_pendaftaran?.[0] || undefined

                              return (
                                <div
                                  key={item.id_data_siswa}
                                  className="p-2 flex items-center gap-3 rounded-xl cursor-pointer hover:bg-secondary"
                                  onClick={() => {
                                    setSelectedSiswa(item)
                                    setShowListSiswa(false)
                                    searchParams.set(
                                      "id",
                                      dataPendaftaran?.nomor_pendaftaran || ""
                                    )
                                    navigate(
                                      `${
                                        location.pathname
                                      }?${searchParams.toString()}`
                                    )
                                  }}
                                >
                                  <FaUser />
                                  <div className="flex items-center gap-3">
                                    <h1>{item.nama_lengkap} |</h1>
                                    <p>{dataPendaftaran?.nomor_pendaftaran}</p>
                                  </div>
                                </div>
                              )
                            })
                          : "Data siswa tidak ditemukan."}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-wrap gap-3">
          <Card
            className={`${
              showPanduan ? "lg:w-[20rem]" : "lg:w-auto w-full"
            } h-fit`}
          >
            <div className="flex justify-between">
              {showPanduan && (
                <h1 className="mb-5 font-bold text-xl">Panduan</h1>
              )}
              <div className="flex items-center flex-col gap-y-3">
                {!showPanduan && (
                  <span className="text-sm font-bold">Panduan</span>
                )}
                <Button
                  variant={"outline"}
                  size={"icon"}
                  onClick={() => setShowPanduan((show) => !show)}
                >
                  <LuChevronRight
                    className={`${
                      showPanduan ? "rotate-90" : "rotate-0"
                    } duration-300`}
                  />
                </Button>
              </div>
            </div>
            <section className="flex flex-col gap-y-3">
              {showPanduan &&
                panduan &&
                panduan.values.map((item, index) => {
                  return (
                    <div key={index}>
                      <h1>{item?.title}</h1>
                      <ul className="ml-5 text-muted-foreground flex flex-col gap-y-1">
                        {item?.instructions
                          .slice(0, visibleCount)
                          .map((instruction, indexInstruction) => {
                            return (
                              <li key={indexInstruction}>
                                {indexInstruction + 1}. {instruction}
                              </li>
                            )
                          })}
                      </ul>
                      {item.instructions.length > visibleCount && (
                        <button
                          onClick={handleLoadMore}
                          className="mt-2 text-blue-500 hover:underline"
                        >
                          Load More
                        </button>
                      )}
                    </div>
                  )
                })}
            </section>
          </Card>
          <Card className="flex-1 overflow-auto h-fit">{loket?.component}</Card>
        </div>
      </section>
    </main>
  )
}
